<template>
  <div>
   <AppSidebar />
    <div class="wrapper d-flex flex-column min-vh-100 bg-light">
      <AppHeader />
      <div class="body flex-grow-1 px-4">
        <TheReminder/>
        <router-view />
      </div>
      <AppFooter />
    </div>
  </div>
</template>
<script>
//import { CContainer } from '@coreui/vue'
import AppFooter from '@/components/AppFooter.vue'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'
import TheReminder from '@/components/TheReminder.vue'

export default {
  name: 'DefaultLayout',
  components: {
    AppFooter,
    AppHeader,
    AppSidebar,
   // CContainer,
    TheReminder,
  },
}
</script>
